// extracted by mini-css-extract-plugin
export default {"responsive-grid-2":"client_responsive-grid-2__zmMRO","column":"client_column__9PLku"};